import { SchoolService, BaseService } from "@/services/school.service";

const AssessmentService = {

    getByCourse(courseId) {
        return SchoolService.getAll("courses/" + courseId + "/assessments")
    },

    // crud
    add(payload) {
    	return SchoolService.create("assessments", payload)
    },

    update(object) {
    	return SchoolService.update("assessments", object.identifier, object)
    },

    delete(object) {
    	return SchoolService.delete("assessments", object.identifier, null)
    },
    
}

export { AssessmentService };